module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_comida-fit.11b86d42.png";